import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { MainModule } from './main/main.module';
import { ResultsModule } from './results/results.module';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { SpinnerHttpInterceptor } from './core/spinner.interceptor';
import { MaterialModule } from './material/material.module';
import { ConfigService } from './shared/config.service';
import { environment } from 'src/environments/environment';

import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { ModalComponent as ModalComponent } from 'src/app/main/modal/modal.component';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { IntermediateEasyclaimTLComponent } from './intermediate-easyclaim-tl/intermediate-easyclaim-tl.component';

function load(http: HttpClient,config: ConfigService) {
  const url = new URL(window.location.href);
  const claimid = url.searchParams.get('claimid');
  const treatmenttype = url.searchParams.get('treatmenttype');
  console.log(claimid);
  const baseUrl = environment.apiEndpoint;
  const API_URL = baseUrl + 'GetConfig/';

  return () => {
//    return http.get('http://localhost:4200/api/EasyClaim/GetConfig/')
    return http.get(API_URL + claimid)
      .toPromise()
      .then((resp) => {
        config.config = resp;
        config.doConfig(claimid, treatmenttype, resp);
        console.log('Response 1 - ', resp);
      });
  };
}

@NgModule({
  declarations: [
    AppComponent,
    WelcomeComponent,
    ModalComponent,
    IntermediateEasyclaimTLComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MainModule,
    ResultsModule,
    ToastrModule.forRoot(),
    AppRoutingModule,
    MaterialModule,
    MatButtonModule,
    MatDialogModule,
    DeviceDetectorModule.forRoot()
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: SpinnerHttpInterceptor,
    multi: true
  },
  {
    provide: APP_INITIALIZER,
    useFactory: load,
    multi: true,
    deps: [HttpClient,
      ConfigService]
  },
  {provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {hasBackdrop: true, direction: 'ltr'}}
],
  bootstrap: [AppComponent],
  entryComponents: [ModalComponent]
})
export class AppModule { }
